import { type RouteObject } from 'react-router'

/**
 * Creates routes for the email confirmation feature.
 */
export function createEmailConfirmationRoutes(): RouteObject[] {
  return [
    {
      path: '/auth/callback/confirm-email',
      lazy: {
        Component: () =>
          import('@/features/email-confirmation/ConfirmEmailView').then(
            (r) => r.default,
          ),
      },
    },
    {
      path: '/email-confirmed',
      lazy: {
        Component: () =>
          import('@/features/email-confirmation/EmailConfirmedView').then(
            (r) => r.default,
          ),
      },
    },
  ]
}
